import React from 'react';
import { Button } from '@mui/material';

const SkeletonBar = ({ className = '' }) => (
  <span className={`court-skeleton-bar ${className}`.trim()} aria-hidden="true" />
);

const SkeletonCard = ({ index }) => (
  <div className="court-skeleton-card" data-testid="court-skeleton-card" aria-hidden="true">
    <div className="court-skeleton-card__heading">
      <span className="court-skeleton-circle" />
      <div className="court-skeleton-card__title">
        <SkeletonBar className={index % 2 === 0 ? 'is-title-wide' : 'is-title'} />
        <SkeletonBar className="is-distance" />
      </div>
      <SkeletonBar className="is-chevron" />
    </div>
    <div className="court-skeleton-card__details">
      <SkeletonBar className="is-address" />
      <SkeletonBar className="is-action" />
    </div>
    <SkeletonBar className="is-pill" />
  </div>
);

export default function CourtCardsSkeleton({
  variant = 'search',
  isFrench = false,
  hasError = false,
  isOffline = false,
  onRetry
}) {
  const loadingLabel = isFrench ? 'Chargement des terrains…' : 'Loading courts…';
  const errorMessage = isOffline
    ? (isFrench
      ? 'Vous êtes hors ligne. Les terrains apparaîtront au retour de la connexion.'
      : 'You’re offline. Courts will appear when your connection returns.')
    : (isFrench
      ? 'Le chargement prend plus de temps que prévu.'
      : 'Loading is taking longer than expected.');

  return (
    <section
      className={`court-loading-skeleton court-loading-skeleton--${variant}`}
      role="status"
      aria-live="polite"
      aria-label={loadingLabel}
    >
      <span className="visually-hidden">{loadingLabel}</span>

      {variant === 'my-courts' && (
        <>
          <div className="court-skeleton-board-heading" aria-hidden="true">
            <SkeletonBar className="is-board-title" />
            <div className="court-skeleton-board-actions">
              <span className="court-skeleton-circle" />
              <span className="court-skeleton-circle" />
            </div>
          </div>
          <SkeletonBar className="is-legend" />
          <div className="court-skeleton-days" aria-hidden="true">
            {Array.from({ length: 5 }, (_, index) => (
              <span className="court-skeleton-day" key={index} />
            ))}
          </div>
        </>
      )}

      {hasError && (
        <div className="court-loading-message">
          <span>{errorMessage}</span>
          <Button size="small" variant="outlined" onClick={onRetry}>
            {isFrench ? 'Réessayer' : 'Retry'}
          </Button>
        </div>
      )}

      <div className="court-skeleton-list">
        {Array.from({ length: 3 }, (_, index) => (
          <SkeletonCard index={index} key={index} />
        ))}
      </div>
    </section>
  );
}
